import { useMemo, useEffect, useRef } from 'react';
import { useSelectedState } from './useSelectedState';
export function useToggleListState(props) {
    var _a;
    var _b = useSelectedState((_a = props.defaultSelected) !== null && _a !== void 0 ? _a : [], props.idKey), selected = _b.selected, propagated = _b.propagated, propagate = _b.propagate, add = _b.add, remove = _b.remove, clear = _b.clear, selectRemaining = _b.selectRemaining;
    var isFirstRun = useRef(true);
    // get all the items that are visible AND NOT selected
    var visibleItems = useMemo(function () {
        return props.visible.filter(function (item) { return !propagated.map(function (s) { return s[props.idKey]; }).includes(item[props.idKey]); });
    }, [props.visible, propagated, props.idKey]);
    // return all propagated items that ARE visible
    var propagatedItems = useMemo(function () {
        return propagated.filter(function (item) {
            return props.visible.map(function (s) { return s[props.idKey]; }).includes(item[props.idKey]);
        });
    }, [props.visible, propagated, props.idKey]);
    // if onChange is provided, call it when the selected list changes
    useEffect(function () {
        if (isFirstRun.current) {
            isFirstRun.current = false;
            return;
        }
        if (props.onChange !== undefined)
            props.onChange(selected);
    }, [selected]);
    // communicate the clicked item back up the tree
    function handleClick(item) {
        return function () {
            if (props.onClick !== undefined)
                props.onClick(item);
        };
    }
    // add all visible items to the selected items
    function handleSelectAll() {
        selectRemaining(visibleItems);
    }
    // use the internal state of Checkbox to communicate if it should be added or
    // removed
    function handleChange(item) {
        return function (e) {
            if (e.currentTarget.checked) {
                add(item);
            }
            else {
                remove(item);
            }
        };
    }
    return {
        clear: clear,
        handleChange: handleChange,
        handleClick: handleClick,
        handleSelectAll: handleSelectAll,
        propagate: propagate,
        visibleItems: visibleItems,
        propagatedItems: propagatedItems,
        selected: selected,
        isPristine: selected.length === propagated.length
    };
}
//# sourceMappingURL=useToggleListState.js.map